import React, { useState, useEffect } from "react";
import { css } from "emotion";
import { stepContent, header, singleInput, phoneCheck } from "./../style";
import InputForm from "../../../../../shared/atoms/InputForm";

import {
	patternOnlyNumbers,
	phoneNumberMask
} from "../../../../../shared/create-offer/utils/masks";

import { useNewOfferMobile } from "../../context";
import { useNewOffer } from "../../../../context/new-offer";
import Callout from "../../../../../shared/create-offer/Callout/Callout";
import ModalLatamPhone from "../../../../../shared/create-offer/ModalPhoneLatam/ModalLatamPhone";
import LatamPhoneWarning from "../../shared/LatamPhoneWarning";

// Debounce function
let timerId;
let fnWaiting;
const debounced = (fn, delay = 250) => {
	if (timerId) clearTimeout(timerId);
	if (!fn && fnWaiting) fnWaiting();
	fnWaiting = fn;
	if (!fn) return;
	timerId = setTimeout(fn, delay);
};

const PhoneRegister = ({ onChangeLoyalty, typePhoneLatam }) => {
	const { currentProgram: fidelityProgram, loyaltyData, phoneMultiplus } = useNewOffer();
	const { setStepError } = useNewOfferMobile();

	const [state, setState] = useState({
		phone: loyaltyData.data.phone || "",
		hasError: false,
		isMaxPhone: loyaltyData.data.isMaxPhone,
		showModalPhone: false
	});

	const [debouncing, setDebouncing] = useState(false);

	useEffect(() => {
		const phone = loyaltyData.data.phone
			? loyaltyData.data.phone
					.match(patternOnlyNumbers)
					.join("")
					.toString()
			: "";
		const isMaxPhone = phone === phoneMultiplus ? 1 : 0;
		const hasError = phone !== undefined && (phone.length !== 11 || phone[2] !== "9");
		setState({
			...state,
			phone: phone,
			isMaxPhone: isMaxPhone,
			hasError: !debouncing && hasError
		});

		setStepError(!phone || hasError || debouncing);
	}, [loyaltyData.data, debouncing]);

	const onChangePhone = value => {
		let phone = value.match(patternOnlyNumbers)
			? value
					.match(patternOnlyNumbers)
					.join("")
					.toString()
			: "";
		const isMaxPhone = phone === phoneMultiplus ? 1 : 0;
		setState({
			hasError: false,
			phone: phone,
			isMaxPhone,
			showModalPhone: false
		});
		setDebouncing(true);
		debounced(() => setDebouncing(false), 1000);
		onChangeLoyalty({ phone: value, isMaxPhone: 1 });
	};

	return (
		<div
			className={css`
				${stepContent};
			`}
		>
			<strong
				className={css`
					${header};
				`}
			>
				Dados da {fidelityProgram.fidelityName}
			</strong>
			{typePhoneLatam !== 1 && (
				<div
					className={css`
						${singleInput};
					`}
				>
					<InputForm
						name="phone"
						id="phone"
						type="tel"
						value={state.phone}
						onChange={ev => {
							onChangePhone(ev.target.value);
						}}
						onBlur={() => debounced(null)}
						onFocus={e => {
							if (state.phone === phoneMultiplus) {
								setState({ ...state, isMaxPhone: 1 });
							}
							if (typePhoneLatam === 0 && !state.phone) {
								setState({ ...state, showModalPhone: true });
							}
						}}
						placeholder=""
						mask={phoneNumberMask}
						label="Telefone no Latam Pass"
						errorMessage={typePhoneLatam === 0 && "Número de celular inválido."}
						helperText={
							state.phone &&
							state.isMaxPhone == 1 &&
							typePhoneLatam === 0 && (
								<div
									className={css`
										${phoneCheck}
									`}
								>
									<i className="icon-check" />
									<p>Telefone confirmado</p>
								</div>
							)
						}
						hasError={typePhoneLatam === 0 && state.hasError}
						data-action="login-offer-phone"
					/>
				</div>
			)}
			{typePhoneLatam === 0 && (
				<>
					<Callout
						show={state.phone && state.isMaxPhone === 0 && typePhoneLatam === 0}
						criticalWarn
						text={
							<span>
								Atenção! É obrigatório adicionar o número de telefone celular da MaxMilhas no seu
								cadastro Latam Pass. Para alterar,{" "}
								<a onClick={() => setState({ ...state, showModalPhone: true })}>clique aqui</a>
								{"."}
							</span>
						}
					/>
					<Callout
						show={state.phone && state.isMaxPhone === -1 && typePhoneLatam === 0}
						criticalWarn
						text={
							<span>
								Este número foi desativado e deve ser alterado para outro telefone indicado pela
								MaxMilhas. Para alterar,{" "}
								<a onClick={() => setState({ ...state, showModalPhone: true })}>clique aqui</a>
							</span>
						}
					/>
					<ModalLatamPhone
						show={state.showModalPhone}
						close={() => setState({ ...state, showModalPhone: false })}
						confirm={value => {
							onChangePhone(value);
							window.document.getElementById("phone").blur();
						}}
						phoneSugestion={phoneMultiplus}
						phone={state.phone}
					/>
					{typePhoneLatam !== 1 && <LatamPhoneWarning phoneMultiplus={phoneMultiplus} />}
				</>
			)}
		</div>
	);
};

export default PhoneRegister;
